import { motion } from 'framer-motion'
import Container from '@comp/ui/container'
import Section from '@comp/ui/section'
import Eyebrow from '@comp/ui/eyebrow'
import Heading from '@comp/ui/heading'
import Text from '@comp/ui/text'

const EASE = [0.22, 1, 0.36, 1] as const

const stats = [
  { value: '15+', label: 'years building identity' },
  { value: '1M+', label: 'identities secured' },
  { value: '4', label: 'global offices' },
  { value: '7,000+', label: 'integrations' },
]

export default function AboutStory() {
  return (
    <Section tone="default" density="spacious">
      <Container size="xl">
        <div className="grid gap-16 lg:grid-cols-[1.1fr_1fr] lg:gap-20">
          <div>
            <Eyebrow>Our story</Eyebrow>
            <Heading as="h2" size="display-lg" className="mt-5">
              Identity that scales,
              <br />
              built since 2010.
            </Heading>
            <div className="mt-10 space-y-6">
              <Text size="xl" tone="secondary">
                Monofor is an identity & access management company with three
                products in production: <strong className="text-ink-primary">Monosign</strong>{' '}
                for IAM,{' '}
                <strong className="text-ink-primary">Monopam</strong> for
                privileged access, and{' '}
                <strong className="text-ink-primary">Monosync</strong> for
                governance.
              </Text>
              <Text size="lg" tone="secondary">
                We unify Identity Governance & Administration (IGA), Access
                Management (AM), and Privileged Access Management (PAM) into a
                single suite, so customers buy one platform, not three vendors.
              </Text>
              <Text size="lg" tone="secondary">
                Built since 2010, in production at 15+ global enterprises since
                2013, securing more than a million identities across financial
                services, retail, transportation, pharmaceuticals, and the
                public sector.
              </Text>
              <Text size="lg" tone="secondary">
                Our mission is simple: help every business reach a secure future
                in information technologies, without making the journey
                harder than the destination.
              </Text>
            </div>
          </div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, ease: EASE }}
            className="grid grid-cols-2 gap-px overflow-hidden rounded-3xl bg-line-subtle"
          >
            {stats.map((s) => (
              <div key={s.label} className="bg-surface p-8 lg:p-10">
                <div className="text-display-lg font-bold text-brand-900 lg:text-display-xl">
                  {s.value}
                </div>
                <p className="mt-3 text-body-lg font-semibold text-ink-primary">
                  {s.label}
                </p>
              </div>
            ))}
          </motion.div>
        </div>
      </Container>
    </Section>
  )
}
